import { Box, Link, Text, VStack } from '@chakra-ui/react'
import { formatPhone, telHref } from '../../lib/contactMethods'
import type { GrantPoc } from '../../types/grant'

/**
 * [Canvasser redesign Phase 1 / spec §4.2, D3] The campaign Point of Contact. Phone and email are
 * tap-to-call / tap-to-mail links AND selectable text. Deliberately no "copy" button: the canvasser
 * subtree carries no clipboard affordance (noExport.guard). Reused by the Phase 7 profile.
 */
export function PointOfContactCard({ poc }: { poc: GrantPoc | null }) {
  return (
    <Box borderWidth="1px" borderColor="border" borderRadius="lg" bg="surface" p={4}>
      <Text fontSize="xs" fontWeight="semibold" color="fg.muted" textTransform="uppercase" mb={2}>
        Your point of contact
      </Text>
      {poc ? (
        <VStack align="start" gap={1}>
          {poc.name && <Text fontWeight="semibold" userSelect="text">{poc.name}</Text>}
          {poc.phone && (
            <Link href={telHref(poc.phone)} color="accent" minH="44px" display="inline-flex" alignItems="center" userSelect="text">
              {formatPhone(poc.phone)}
            </Link>
          )}
          {poc.email && (
            <Link href={`mailto:${poc.email}`} color="accent" minH="44px" display="inline-flex" alignItems="center" userSelect="text" wordBreak="break-all">
              {poc.email}
            </Link>
          )}
        </VStack>
      ) : (
        <Text color="fg.muted" fontSize="sm">Your organizer hasn't added a contact yet.</Text>
      )}
    </Box>
  )
}
